import Tooltip from './Tooltip'

export default function FormFieldRadioButtonGroup (props) {
  return (
    <>
      {props.label && (
        <label>
          {props.label}{props.required ? '*' : ''}
          {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
        </label>
      )}
      <div className="wp-block-gds-lead-form__form-field wp-block-gds-lead-form__form-field--radio-group">
        {props.children}
      </div>
    </>
  )
}
